import { ContainedIcon } from '@frontend/icons';

export const ScheduleConfirmed = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: 'var(--fabric-radius-sm)',
      }}
      iconName='calendar-confirmed'
      color={'var(--fabric-color-blue-70)'}
    />
  );
};
